import { createTheme } from '@mui/material/styles';
import createTypography from './typography';
import spacing from './spacing';
import shadows from './shadows';
import createOverrides from './overrides';
import * as ThemePaletteOptions from './palettes';

const defaultPalette = {
  common: {
    white: '#ffffff',
  },
  primary: {
    main: '#8E47FB',
  },
  secondary: {
    main: '#ffc208',
  },
  text: {
    primary: '#233044',
    secondary: '#9198A2',
    danger: '#F0142F',
    disabled: '#D7DBEC',
  },
  background: {
    default: '#F7F9FC',
  },
};

const theme = (paletteKey = 'defaultTheme') => {
  const palette = ThemePaletteOptions[paletteKey] || defaultPalette;

  return createTheme({
    palette,
    typography: createTypography(),
    spacing,
    shadows,
    components: createOverrides(palette),
    props: {
      MuiButtonBase: {
        disableRipple: true,
      },
    },
    shape: {
      // borderRadius: 16,
    },
  });
};

export default theme;
